import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import FormContainer from '../components/FormContainer';
import { toast } from 'react-toastify';
import {
  useGetUserDetailsQuery,
  useUpdateUserMutation,
} from '../slices/userApiSlice';

const UserEditScreen = () => {
  const { id: userId } = useParams();

  const [role, setRole] = useState('');

  const navigate = useNavigate();

  const {
    data: user,
    isLoading,
    error,
    refetch,
  } = useGetUserDetailsQuery(userId);

  const [updateUser, { isLoading: loadingUpdate }] = useUpdateUserMutation();

  useEffect(() => {
    if (user) {
      setRole(user.role || '');
    }
  }, [user]);

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      await updateUser({
        userId,
        role,
      });
      toast.success('User role updated successfully');
      refetch();
      navigate('/userList');
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return (
    <>
      <Link to="/userList" className="btn btn-light my-3">
        Go Back
      </Link>
      <FormContainer>
        <h1>Edit User Role</h1>

        {loadingUpdate && <Loader />}
        {isLoading ? (
          <Loader />
        ) : error ? (
          <Message variant="danger">
            {error?.data?.message || error.error}
          </Message>
        ) : (
          <Form onSubmit={submitHandler}>
            {/* Name */}
            <Form.Group className="my-2" controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control plaintext readOnly defaultValue={user.name} />
            </Form.Group>

            {/* Email */}
            <Form.Group className="my-2" controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                plaintext
                readOnly
                defaultValue={user.email || 'N/A'}
              />
            </Form.Group>

            {/* Phone */}
            <Form.Group className="my-2" controlId="phone">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                plaintext
                readOnly
                defaultValue={user.phone || 'N/A'}
              />
            </Form.Group>

            {/* Address (first one only) */}
            {user.addresses && user.addresses.length > 0 && (
              <Form.Group className="my-2" controlId="address">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  plaintext
                  readOnly
                  defaultValue={
                    `${user.addresses[0].address}, ${user.addresses[0].area}, ${user.addresses[0].city} - ${user.addresses[0].pincode}` +
                    (user.addresses[0].phoneNumber
                      ? `\nPhone: ${user.addresses[0].phoneNumber}`
                      : '')
                  }
                />
              </Form.Group>
            )}

            {/* Role - Editable */}
            <Form.Group className="my-2" controlId="role">
              <Form.Label>Role</Form.Label>
              <Form.Select
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <option value="">Select Role</option>
                <option value="admin">Admin</option>
                <option value="user">User</option>
                <option value="vendor">Vendor</option>
                <option value="delivery">Delivery</option>
              </Form.Select>
            </Form.Group>

            <Button type="submit" variant="primary" className="mt-3">
              Update Role
            </Button>
          </Form>
        )}
      </FormContainer>
    </>
  );
};

export default UserEditScreen;
